import React, {useEffect, useState} from 'react';
import moment from 'moment';
import * as FileSaver from '../../../../vendor/FileSaver';
import t from '../../helpers/t';
import { Biscuit } from '../../../utils';
import { rbac } from './index';
import {getApiHost} from "../../../Sync";
import {s3Actions,useSelector} from "inbooma-api";

export default props => {

    const _getDocument = useSelector(state => state.s3_data.getDocumentS3);
    const [getDocumentPending, setGetDocumentPending] = useState(false);
    const entityType = (typeof props.folder !== 'undefined' ? 'folder' : 'file'),
          entity = (entityType === 'folder'
                    ? props.folder
                    : props.file), 
          created = moment(entity.created);

    useEffect(() => {
        if(_getDocument.success === '' || !getDocumentPending){
            return;
        }
        if(_getDocument.success === true){
           const blob = new Blob([_getDocument.data], { type: _getDocument.data.type });
            FileSaver.saveAs(blob, getDocumentPending.replace(/_/gi, ' '));
        } else {
            alert('Could not download: ' + _getDocument.data);
        }
        setGetDocumentPending(false);
    }, [_getDocument])

    const onClickEditEntity = () => {
        props.onClickEditEntity(entity.id);
    }

    const onClickFile = (file) => {
        props.dispatch(s3Actions.getDocumentS3({
            client_id: Biscuit.get('user.client_id'),
            type: 'UserDoc',
            location: 0,
            name: file,
            apiEntryPoint: getApiHost(),
            token: Biscuit.get('token')
        }));
        setGetDocumentPending(file);
    }

    //if (entityType === 'file') console.log('ENTITY', Object.freeze(entity.tags));

    return (
        <div
            className="inb-c-item-details-row row"
            data-upload-status={typeof entity.uploadStatus !== 'undefined' ? entity.uploadStatus : ''} // upload_progressed | uploaded
            data-entity-id={entity.id}>
                {entityType === 'folder' ? (
                    <div
                     className="entity-title small-8 column"
                     data-entity-id={entity.id}
                     onClick={props.onClickOpenFolder}>
                        <i className="fi fi-folder entity-icon"></i>  
                        {entity.name}                        
                    </div>
                ) : (
                    <div
                     className="entity-title small-8 column"
                     title={entity.description}>
                        {typeof entity.uploadStatus !== 'undefined' ?
                        <>
                            <i className="fi fi-upload-cloud entity-icon"></i>                          {entity.file} 
                            {entity.file} 
                            <span> {t('upload_in_progress')}</span>
                        </>
                        : 
                        <>
                            <i className="fi fi-page entity-icon"></i>  
                            {/* Before implementing S3.getDocument: <a
                             className="file-link"
                             target="_blank"
                             rel="noopener noreferrer"
                             title={t('open_external_link')}
                             href={entity.file}>
                               {entity.description} 
                            </a>*/}
                            <a 
                                className="file-link"
                                href="#"
                                onClick={() => onClickFile(entity.file)}>
                                {entity.description} 
                            </a>
                        </>
                        }

                        {typeof entity.tags !== 'undefined'
                         && rbac.hasPermission('editTags')
                         && entity.tags !== ''
                         && entity.tags.map(tag => (
                            <div
                             key={tag.label}
                             className="badge secondary"
                             style={{borderRadius:'3px',fontWeight:'bold',fontSize:'0.7rem',marginLeft:'10px',color:'#fff'}}>
                              {typeof tag.label !== 'undefined' ? tag.label : tag.value}
                            </div>
                        ))}
                    </div>
                )}
            <div className="small-2 column">
                {created.isValid() &&
                    <>
                    {created.format('dd, DD.MM.YY HH:mm')}
                    </>
                }
            </div>

            <div className="small-2 column">
                {entityType === 'folder' && rbac.hasPermission('editFolder') &&
                <a
                 href="#"
                 onClick={onClickEditEntity}>
                    {t('edit_${a}',{a:t('folder')})}
                </a>
                }
                {entityType === 'file' && rbac.hasPermission('editDocument') && typeof entity.uploadStatus === 'undefined' &&
                <a
                 href="#"
                 onClick={onClickEditEntity}>
                    {t('edit_${a}',{a:t('document')})}
                </a>
                }
            </div>
        </div>
    );
};